import { Injectable } from '@angular/core';
import { FC_CpuCoolerCpu } from '../funcionesCompatibilidad/FC_CpuCoolerCpu';
import { FC_CpuMother } from '../funcionesCompatibilidad/FC_CpuMother';
import { Cpu } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';

@Injectable({
  providedIn: 'root',
})
export class FA_Cpu extends FuncionesArmadoBase<Cpu> {
  constructor(
    private fc_CpuMother: FC_CpuMother,
    private fc_CpuCoolerCpu: FC_CpuCoolerCpu,
  ) {
    super();
  }
  funciones = {
    mother: (dataArmado: DataArmado, cpu: Cpu) => {
      let mother = dataArmado.mother[0];
      if (!mother) return [];
      return this.fc_CpuMother.ejecutar(cpu, mother);
    },
    coolerCpu: (dataArmado: DataArmado, cpu: Cpu) => {
      let coolerCpu = dataArmado.ccpu[0];
      if (!coolerCpu) return [];
      return this.fc_CpuCoolerCpu.ejecutar(cpu, coolerCpu);
    },
  };
}
